import RequireAuthentication from "../component/require/RequireAuthentication"
import { useEffect } from "react"
import { useNavigate, useParams } from "react-router-dom"
import { MarkReportAsReadSpecification } from "pokal_api"
import {
    NAVIGATION_VIEW,
    NavigationPaths
} from "../navigation/NavigationController"

function ReportReadView() {
    const { report } = useParams()
    const navigate = useNavigate()

    useEffect(() => {
        if (report !== undefined) {
            MarkReportAsReadSpecification.request({
                report
            }).then(() => {
                navigate(
                    NavigationPaths[NAVIGATION_VIEW.PATIENT_SELECTION_VIEW].path
                )
            })
        }
    }, [report])

    return (
        <RequireAuthentication>
            <></>
        </RequireAuthentication>
    )
}

export default ReportReadView
